<template>
  <div class="products">
    <div class="data-container">
      <b-table
        id="products-tab-list"
        show-empty
        :items="productsList"
        :empty-text="loading ? 'Loading data' : 'No product records found'"
        :fields="fields"
        responsive
        @row-hovered="toggleActions($event, true)"
        @row-unhovered="toggleActions($event, false)"
      >
        <template slot="HEAD_product_id">
          <div class="text-center pt-0 pb-0 pl-0 pr-0">
            <b-form-checkbox
              v-model="selectAllProducts"
              @click.native.stop
              value="all"
              unchecked-value="false"
            >
            </b-form-checkbox>
          </div>
        </template>
        <template slot="product_id" slot-scope="data">
          <div class="text-center pt-0 pb-0 pl-0 pr-0">
            <b-form-checkbox
              class="pt-0 pb-0 pl-4 pr-0"
              v-model="selectedProducts"
              :value="data.item.uuid"
            >
            </b-form-checkbox>
          </div>
        </template>
        <template slot="regular_price" slot-scope="data">
          ₱ {{ data.item.regular_price | regularPrice }}
        </template>
        <template slot="variation_code" slot-scope="data">
          {{ transformVariationName(data.item.decoded_variation_code) }}
          <div
            v-if="data.item._showActions"
            class="row-hovered-actions position-absolute d-flex"
          >
            <i class="action-button bg-white rounded shadow mx-1 p-1 border">
              <img
                src="@/assets/images/actions/edit.svg"
                alt="Edit Button"
                @click="
                  $router.push({
                    name: 'UpdateProduct',
                    params: {
                      uuid:
                        data.item.product_details.type === 'simple'
                          ? data.item.uuid
                          : data.item.product_details.uuid,
                      type: data.item.product_details.type,
                      page: pagination.currentPage
                    },
                  })
                "
              />
            </i>
            <i
              class="action-button bg-white rounded shadow mx-1 p-1 border"
              @click="
                deleteProduct({
                  uuid: data.item.uuid,
                  name: data.item.product_details.name,
                  is_tagged: data.item.is_tagged_count,
                })
              "
            >
              <img
                src="@/assets/images/actions/delete.svg"
                alt="Delete Button"
              />
            </i>
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Switches from "vue-switches";
import moment from "moment";
import _ from "lodash";

export default {
  name: "InventoryTable",
  data() {
    return {
      selectedProducts: [],
      fields: [
        {
          key: "product_id",
          thStyle: { width: "5%", padding: "12px 12px 12px 12px" },
          trStyle: { width: "5%", padding: "12px 12px 12px 12px" },
        },
        {
          key: "product_name",
          sortable: true,
          thClass: "font-weight-bold",
        },
        {
          key: "category_name",
          label: "Category",
          sortable: true,
          thClass: "font-weight-bold",
        },
        {
          key: "regular_price",
          label: "Price",
          sortable: true,
          thClass: "font-weight-bold",
        },
        {
          key: "variation_code",
          label: "Variation",
          sortable: true,
          thClass: "font-weight-bold",
          tdClass: "position-relative",
        },
      ],
      selectAllProducts: false,
      selectAll: false,
    };
  },
  components: {
    Switches,
  },
  mounted() {
    this.$root.$on("productDeletedFetchProductList", () => {
      this.getProducts();
    });

    this.$root.$on("onMultipleDelete", () => {
      this.selectAllProducts = false;
      this.selectAll = false;
      this.selectedProducts = [];
    });
  },
  created: function () {
    this.param.payload = {
      column: "all",
      keyword: "",
      paired_key: "all"
    };
    this.getProducts();
    this.debounceGetProducts = _.debounce((param) => {
      this.$store.dispatch("estoreInventories/getProducts", param);
    }, 300);
  },
  beforeDestroy() {
    this.$root.$off("productDeletedFetchProductList");
  },
  computed: {
    ...mapState("estoreInventories", [
      "loading",
      "param",
      "products",
      "categories",
      "modal",
      "pagination",
    ]),
    ...mapState("auth", ["user"]),
    uncheck() {
      return this.pagination.currentPage;
    },
    productsList() {
      return this.products.map((keys, index) => ({
        ...keys,
        product_name: this.products[index].product_details.name,
        category_name: this.getCategoryName(
          this.products[index].product_details.category_id
        ),
        _showActions: false,
      }));
    },
  },
  filters: {
    formatDate: function (value) {
      if (value) {
        return moment(String(value)).format("MMM. D, YYYY");
      }
    },
    regularPrice: function (value) {
      return Number.parseFloat(value).toFixed(2);
    },
    salePrice: function (price, discount, discountType) {
      if (discountType === "PHP") {
        let formatDiscount = price - discount;
        return formatDiscount.toFixed(2);
      } else {
        let formatDiscount = price - price * (discount / 100);
        return formatDiscount.toFixed(2);
      }
    },
  },
  methods: {
    getProducts: async function () {
      await this.$store.dispatch("estoreInventories/getProducts", this.param);
    },

    getCategoryName: function (id) {
      let category = {};

      if (this.categories.length > 0)
        category = this.categories.find((category) => category.id === id);

      if (category) return category.name;
      else return;
    },

    async editProduct(param) {
      this.$store.commit("estoreInventories/setModal", {
        type: "edit_product",
        status: true,
      });
      await this.$store.dispatch("branches/getBranches", true);
      await this.$store.dispatch("estoreInventories/getProduct", {
        uuid: param.product_type == "simple" ? param.uuid : param.product_uuid,
        type: param.product_type,
      });
    },

    deleteProduct: function (param) {
      this.$store.commit("estoreInventories/setModal", {
        type: "delete_product",
        uuid: param.uuid,
        name: param.name,
        is_tagged: param.is_tagged,
        status: true,
      });
    },

    updateVisibility: function (param) {
      let data = {
        uuid: param.uuid,
        param: {
          visibility: param.visibility,
        },
      };
      this.$store.dispatch("estoreInventories/updateProductVisibility", data);
    },
    transformVariationName: function (decodedVariationCode) {
      let variationCode = "";
      if (decodedVariationCode.length >= 1) {
        for (const code of decodedVariationCode) {
          variationCode += code.value + " - ";
        }
        return variationCode.substring(0, variationCode.length - 3);
      } else {
        return "N/A";
      }
    },
    toggleActions($event, value) {
      this.productsList.find(
        (product) => product.uuid === $event.uuid
      )._showActions = value;
    },
  },
  watch: {
    param: {
      deep: true,
      handler(value) {
        this.debounceGetProducts(value);
      },
    },
    uncheck(newVal, oldVal) {
      if (oldVal != newVal) {
        this.selectAllProducts = false;
        this.selectAll = false;
        this.selectedProducts = [];
        this.modal.delete_multiple_products.product_ids = [];
      }
    },
    selectAllProducts: function (value) {
      if (this.selectAllProducts === "all") {
        this.selectAll = true;
      } else if (value === "false" || this.selectAll === null) {
        this.selectAll = false;
      } else {
        this.selectAll = "unselect";
      }
    },
    selectAll: function (value) {
      this.selectedValues = [];
      if (value === true) {
        for (let item in this.products) {
          if (!this.selectedProducts.includes(this.products[item].uuid)) {
            this.selectedProducts.push(this.products[item].uuid);
          }
        }
      } else if (value === false) {
        for (let item in this.products) {
          this.selectedProducts = this.selectedProducts.filter(
            (e) => e !== this.products[item].uuid
          );
        }
      }
    },
    selectedProducts: function () {
      let selectedIsTagged = 0;
      for (let item in this.products) {
        if (this.selectedProducts.includes(this.products[item].uuid)) {
          if (this.products[item].is_tagged_count > 0) {
            selectedIsTagged = 1;
            break;
          }
        }
      }

      if (
        this.selectedProducts.length == this.products.length &&
        this.selectedProducts.length != 0
      ) {
        this.selectAllProducts = "all";
      } else {
        this.selectAllProducts = "unselect";
      }

      this.$store.commit("estoreInventories/setModal", {
        type: "delete_multiple_products",
        product_ids: this.selectedProducts,
        merchant_uuid: this.user.merchant_uuid,
        has_tagged_products: selectedIsTagged,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.row-hovered-actions {
  right: 3px;
  top: 4px;
}
</style>

<style lang="scss">
.data-container table#products-tab-list {
  box-shadow: -1px 0px 0px 0px #e9ebed inset;
  border-radius: 10px;
  overflow: hidden;
  thead {
    box-shadow: none;
    th {
      &:first-child {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 0;
      }
      &:last-child {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 0;
      }
    }
  }
  tbody {
    &:before {
      display: none;
    }
    tr {
      box-shadow: none;
      &:first-child > td:first-child {
        border-top-left-radius: 0;
      }
      &:last-child > td:first-child {
        border-bottom-left-radius: 10px;
      }
    }
  }
}
</style>